import { render, staticRenderFns } from "./ModalQuickPayment.vue?vue&type=template&id=2536af20&scoped=true&"
import script from "./ModalQuickPayment.vue?vue&type=script&lang=js&"
export * from "./ModalQuickPayment.vue?vue&type=script&lang=js&"
import style0 from "./ModalQuickPayment.vue?vue&type=style&index=0&id=2536af20&lang=scss&scoped=true&"
import style1 from "./ModalQuickPayment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536af20",
  null
  
)

export default component.exports